module.exports = __webpack_public_path__ + "static/media/essence-of-kernelcon-1.5c2f6fc3.jpeg";